import { render, staticRenderFns } from "./autodamage.vue?vue&type=template&id=005b8b02"
import script from "./autodamage.vue?vue&type=script&lang=js"
export * from "./autodamage.vue?vue&type=script&lang=js"
import style0 from "./autodamage.vue?vue&type=style&index=0&id=005b8b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports